// Greenlight web app entry point
// pipeline test: trigger web build & rollout — safe to remove
// build trigger 2026-07-01: rebuild greenlight-web — safe to remove
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
